import { Reveal } from "./Reveal";

export function ClinicNotes({ updates }) {
  if (!updates.length) return null;
  return (
    <section className="clinic-notes">
      <div className="container">
        <div className="section-label">From the clinic</div>
        <div className="notes-list">{updates.map((u) => <Reveal key={u.id}><p className="note-item" data-testid={`update-${u.id}`}>{u.text}</p></Reveal>)}</div>
      </div>
    </section>
  );
}
